
import { DefaultState } from 'store/types';

export const REMOVE_GUEST_FROM_ROOM_REQUEST = 'REMOVE_GUEST_FROM_ROOM_REQUEST';
export const REMOVE_GUEST_FROM_ROOM_SUCCESS = 'REMOVE_GUEST_FROM_ROOM_SUCCESS';
export const REMOVE_GUEST_FROM_ROOM_FAILURE = 'REMOVE_GUEST_FROM_ROOM_FAILURE';


export interface RemoveGuestFromRoomParams {
  lodgingRequestId: string;
  reservationProviderId: string;
  moveToCancel: boolean;
  doNotSendNotificationToAssociate: boolean;
  doNotSendNotificationToCLC?: boolean;
}

export interface RemoveGuestFromRoomData {

}

export type RemoveGuestFromRoomState = DefaultState & {
  contents?: RemoveGuestFromRoomData;
};

interface RemoveGuestFromRoomDataRequest {
  type: typeof REMOVE_GUEST_FROM_ROOM_REQUEST;
}

interface RemoveGuestFromRoomDataSuccess {
  type: typeof REMOVE_GUEST_FROM_ROOM_SUCCESS,
  contents: RemoveGuestFromRoomData;
}

interface RemoveGuestFromRoomDataFailure {
  type: typeof REMOVE_GUEST_FROM_ROOM_FAILURE;
}

export type RemoveGuestFromRoomActionTypes = RemoveGuestFromRoomDataRequest | RemoveGuestFromRoomDataSuccess | RemoveGuestFromRoomDataFailure;